// extracted by mini-css-extract-plugin
module.exports = {"details":"Accordion-module__details___1trO9","content":"Accordion-module__content___1_Nrq"};